import { Navigate } from 'react-router-dom'

import { useAppStore } from '@runtime/core/store/appStore'
import { isAdminUserRole } from '@runtime/core/user/userRole'

import StudioAccessDeniedPage from './StudioAccessDeniedPage'

export default function StudioLoginRoute() {
  const authToken = useAppStore(state => state.authToken)
  const user = useAppStore(state => state.user)

  if (authToken && !user) {
    return null
  }

  if (isAdminUserRole(user?.role)) {
    return <Navigate to="/" replace />
  }

  return (
    <StudioAccessDeniedPage
      mode={authToken ? 'insufficient-permissions' : 'login'}
      accountLabel={user?.email || user?.pseudo || null}
    />
  )
}
